/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { cartLinesStyles } from "@monsma/Overrides/Widgets/Cart/CartLines";
import Folder from "@monsma/XDL/Icons/Folder";
import Save from "@monsma/XDL/Icons/Save";
import { removeLinkStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

cartLinesStyles!.header!.mainSection = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: end;
        padding-bottom: 15px;
    `,
};

cartLinesStyles.headerWrapper = {
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
    `,
};

cartLinesStyles!.header!.removeAllLink = {
    ...removeLinkStyle,
    // css just to push it to end
    css: css`
        ${removeLinkStyle?.css}
        margin-left: auto;
    `,
};

cartLinesStyles!.xHeader = {
    saveOrder: {
        icon: {
            iconProps: {
                src: Save,
                size: 12,
                color: "common.ui5",
            },
            position: "left",
        },
    },
    addAllToList: {
        icon: {
            iconProps: {
                src: Folder,
                size: 12,
                color: "common.ui5",
            },
            position: "left",
        },
        css: css`
            ${getProp("theme.link.defaultProps.css")};
            margin-left: 60px;
        `,
    },
    notificationContainers: {
        extendedStyles: {
            cssOverrides: {
                toast: css`
                    && {
                        width: 100%;
                    }
                `,
            },
        },
    },
};
